import { Component } from 'react'
import PropTypes from 'prop-types'

class ErrorManager extends Component {
    constructor(props) {
        super(props)

        // Expose the commands to dev console
        window.showError = this.showError
    }

    shouldComponentUpdate() {
        return false
    }

    // Show error that should create a notification in the UI when called
    showError = (title, message, timeout, persistent = false) => {
        this.props.showError({
            title,
            content: message,
            timeout,
            alwaysOnTop: true,
            persistent,
        })
    }

    render() {
        return null
    }
}

ErrorManager.propTypes = {
    showError: PropTypes.func,
}

export default ErrorManager



// WEBPACK FOOTER //
// ./src/features/Backend/components/Backend/components/ErrorManager/component.js